/* eslint-disable import/no-anonymous-default-export */
import { useAppSelector } from '../store/hooks'
import { trailsRepository } from '@/repositories'

function useGetMatriculate() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data, isLoading } = trailsRepository.useGetMatriculateQuery({
		userId: user?.id || 0,
	})

	return { data, isLoading }
}

export default {
	getMatriculate: useGetMatriculate,
}
